import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Component from './Component';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoadingAddOns, addOns, message, error, isLoading, updatedAddons,
  } = state.master;
  return {
    isLoadingAddOns,
    addOns,
    message,
    error,
    isLoading,
    updatedAddons,
  };
}

const Styled = withStyles(styles)(Component);

export default connect(
  mapStateToProps,
)(Styled);
